export default __webpack_public_path__ + "static/media/34.7e9f8756.jpg";